var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 1.804 13.696.5 7.5 6.696 1.304.5 0 1.804 6.196 8 0 14.196 1.304 15.5 7.5 9.304l6.196 6.196L15 14.196 8.804 8z"
})));
export default SvgClose;